require('../../modules/es.array.sort');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Array', 'sort');
